module.exports = __webpack_public_path__ + "img/u48.474294f5.png";